module.exports = __webpack_public_path__ + "img/hestia.4c567263.jpeg";